import React, { Component } from "react";
import { Dropdown, Menu, Spin, Tag, Row, Col, Empty, Popconfirm, Tooltip } from "antd";
import { FileExcelOutlined, FilePdfOutlined, DownloadOutlined, StopOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { ButtonItem, RangePickerItem, TableItem, MensajeError } from "../../../../Components/Items";
import { limpiarNombreArchivo } from "../../../../Components/ExcelTablaReporte";
import reporteTiemposMuertosPdf from "../../../../Pdf/reporteTiemposMuertosPdf";
import { estiloBarraFiltros } from "../OrdenesDeProduccionPU/PlaneacionProduccionPU/planeacion.utils";
import { resumirParos, formatoMinutos, nombreCompleto, descargarTiemposMuertosExcel } from "./reporteTiemposMuertos.utils";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const tarjeta = { backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)", marginBottom: 12 };

class ReporteTiemposMuertosPU extends Component {
  state = { loading: false, fechas: [moment().startOf("week"), moment().endOf("day")], paros: [] };

  componentDidMount() {
    this.consultar();
  }

  consultar = (conEmpresa = false) => {
    this.setState({ loading: true });
    return axios
      .post(
        "tiemposMuertosPU/reporteParos",
        {
          empresaId: this.props.empresaId,
          desde: this.state.fechas[0].clone().startOf("day").toDate(),
          hasta: this.state.fechas[1].clone().endOf("day").toDate(),
          conEmpresa,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ paros: res.data.paros || [] });
          return res.data;
        }
        MensajeError({ message: res.data.error || "No se pudo generar el reporte" });
        return null;
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
        return null;
      });
  };

  cancelarParo = (paroId) => {
    axios
      .post("tiemposMuertosPU/cancelarParo", { empresaId: this.props.empresaId, usuarioId: this.props.usuarioId, paroId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.consultar();
        else MensajeError({ message: res.data.error || "No se pudo cancelar el paro" });
      })
      .catch(() => MensajeError({ message: "Error al conectar con el servidor" }));
  };

  descripcion = () => `Del ${this.state.fechas[0].format("DD/MM/YYYY")} al ${this.state.fechas[1].format("DD/MM/YYYY")}`;

  nombreArchivo = () => `${moment().format("DD MM YYYY")} Tiempos_muertos_${limpiarNombreArchivo(this.descripcion())}`;

  descargarExcel = () =>
    descargarTiemposMuertosExcel({ paros: this.state.paros, empresaNombre: this.props.empresaNombre, descripcion: this.descripcion(), nombreArchivo: this.nombreArchivo() });

  descargarPdf = () =>
    this.consultar(true).then((datos) => {
      if (!datos) return;
      pdfMake
        .createPdf(reporteTiemposMuertosPdf({ paros: datos.paros || [], empresa: datos.empresa || { nombre: this.props.empresaNombre }, descripcion: this.descripcion(), usuarioNombre: this.props.usuarioNombre }))
        .download(`${this.nombreArchivo()}.pdf`);
    });

  render() {
    const { paros } = this.state;
    const resumen = resumirParos(paros);
    const columnas = [
      { title: "Fecha", key: "fecha", width: 100, render: (_, p) => moment(p.fechaParo).format("DD/MM/YYYY") },
      { title: "Hora de paro", key: "paro", width: 100, render: (_, p) => moment(p.fechaParo).format("HH:mm") },
      {
        title: "Hora de arranque",
        key: "arranque",
        width: 120,
        render: (_, p) => (p.fechaArranque ? moment(p.fechaArranque).format(moment(p.fechaArranque).isSame(p.fechaParo, "day") ? "HH:mm" : "DD/MM HH:mm") : <Tag color="red">Abierto</Tag>),
      },
      { title: "Tiempo muerto", key: "minutos", width: 110, align: "center", render: (_, p) => <b>{formatoMinutos(p.minutos)}</b> },
      { title: "Código", dataIndex: "codigo", key: "codigo", width: 80 },
      { title: "Origen", dataIndex: "origen", key: "origen", width: 130 },
      { title: "Motivo", dataIndex: "motivo", key: "motivo" },
      { title: "Registró", key: "usuario", width: 200, render: (_, p) => nombreCompleto(p.usuarioId) },
      { title: "Observaciones", dataIndex: "observaciones", key: "observaciones" },
      {
        title: "Acción",
        key: "accion",
        width: 80,
        align: "center",
        render: (_, p) => (
          <Popconfirm title="¿Cancelar este paro? Ya no contará como tiempo muerto." onConfirm={() => this.cancelarParo(p._id)}>
            <Tooltip title="Cancelar paro">
              <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
            </Tooltip>
          </Popconfirm>
        ),
      },
    ];
    const columnasResumen = (conCodigo) => [
      ...(conCodigo ? [{ title: "Código", dataIndex: "codigo", key: "codigo", width: 80 }] : []),
      { title: "Origen", dataIndex: "origen", key: "origen" },
      ...(conCodigo ? [{ title: "Motivo", dataIndex: "motivo", key: "motivo" }] : []),
      { title: "Paros", dataIndex: "paros", key: "paros", width: 70, align: "right" },
      { title: "Tiempo", key: "tiempo", width: 90, align: "right", render: (_, f) => formatoMinutos(f.minutos) },
      { title: "%", dataIndex: "porcentaje", key: "porcentaje", width: 70, align: "right", render: (v) => `${v}%` },
      { title: "% acum.", dataIndex: "porcentajeAcumulado", key: "porcentajeAcumulado", width: 80, align: "right", render: (v) => `${v}%` },
    ];
    const menuDescarga = (
      <Menu>
        <Menu.Item key="excel" icon={<FileExcelOutlined style={{ color: "#217346" }} />} onClick={this.descargarExcel}>
          Excel
        </Menu.Item>
        <Menu.Item key="pdf" icon={<FilePdfOutlined style={{ color: "#df0101" }} />} onClick={this.descargarPdf}>
          PDF
        </Menu.Item>
      </Menu>
    );

    return (
      <>
        <div style={estiloBarraFiltros}>
          <RangePickerItem allowClear={false} value={this.state.fechas} format="DD/MM/YYYY" onChange={(fechas) => fechas && this.setState({ fechas }, () => this.consultar())} />
          <span style={{ fontWeight: 600, color: "#1a3a4a" }}>Tiempo muerto total: {formatoMinutos(resumen.totalMinutos)}</span>
          <div style={{ flex: 1 }} />
          <Dropdown overlay={menuDescarga} trigger={["click"]}>
            <ButtonItem cyan botonAncho icon={<DownloadOutlined />}>
              Descargar
            </ButtonItem>
          </Dropdown>
        </div>
        <Spin spinning={this.state.loading}>
          <div style={tarjeta}>
            {paros.length === 0 ? <Empty description="No hay paros en este periodo" /> : <TableItem size="small" dataSource={paros} columns={columnas} rowKey="_id" />}
          </div>
          {paros.length > 0 && (
            <Row gutter={12}>
              <Col span={10}>
                <div style={tarjeta}>
                  <b>Por origen</b>
                  <TableItem size="small" dataSource={resumen.porOrigen} columns={columnasResumen(false)} rowKey="origen" />
                </div>
              </Col>
              <Col span={14}>
                <div style={tarjeta}>
                  <b>Por código</b>
                  <TableItem size="small" dataSource={resumen.porCodigo} columns={columnasResumen(true)} rowKey="codigo" />
                </div>
              </Col>
            </Row>
          )}
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  empresaNombre: state.empresa.nombre,
  usuarioId: state.user.usuarioId,
  usuarioNombre: [state.user.nombre, state.user.apellidoPaterno, state.user.apellidoMaterno].filter(Boolean).join(" "),
});

export default connect(mapStateToProps)(ReporteTiemposMuertosPU);
